/* eslint-disable jsx-a11y/no-static-element-interactions */

/* eslint-disable jsx-a11y/click-events-have-key-events */

/* eslint-disable no-unused-expressions */
import classNames from 'classnames'
import React from 'react'

import { calendarDayFormatFrom } from '../../constants/calendar'
import moment from '../../utils/moment'
import DayPicker from '../../vendors/Daypicker'

class CalendarDayPickerBar extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      showDayPicker: false,
    }

    this.handleDayClick = this.handleDayClick.bind(this)
    this.handleShowDayPicker = this.handleShowDayPicker.bind(this)
    this.handleHideDayPicker = this.handleHideDayPicker.bind(this)
  }

  handleDayClick(day, { selected }) {
    const selectedDay = selected ? undefined : day
    // biome-ignore lint/complexity/useOptionalChain: TODO
    this.props.onChange && this.props.onChange(selectedDay)
  }

  handleShowDayPicker() {
    this.setState({
      showDayPicker: true,
    })
  }

  handleHideDayPicker() {
    this.setState({
      showDayPicker: false,
    })
  }

  render() {
    const { showDayPicker } = this.state
    const { className, selectedDay } = this.props

    return (
      <div className={classNames(className, 'calendar-daypicker-container position-relative')}>
        {/** biome-ignore lint/a11y/useAriaPropsSupportedByRole: TODO */}
        {/** biome-ignore lint/a11y/noStaticElementInteractions: TODO */}
        {/** biome-ignore lint/a11y/useKeyWithClickEvents: TODO */}
        <span onClick={this.handleShowDayPicker} aria-label="Select Day">
          {moment(selectedDay).format(calendarDayFormatFrom)}
        </span>
        {showDayPicker && (
          // biome-ignore lint/a11y/noStaticElementInteractions: TODO
          <div className="calendar-daypicker-wrapper position-absolute" onMouseLeave={this.handleHideDayPicker}>
            <DayPicker
              className="calendar-daypicker"
              initialMonth={moment(selectedDay).toDate()}
              selectedDays={moment(selectedDay).toDate()}
              onDayClick={this.handleDayClick}
            />
          </div>
        )}
      </div>
    )
  }
}

CalendarDayPickerBar.defaultProps = {
  onChange: null,
  selectedDay: new Date(),
}

export default CalendarDayPickerBar
